import Link from "@mui/material/Link";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import ErrorsCatcher from "../ErrorsCatcher/Tsx/ErrorsCatcher";
import {Button} from "@mui/material";
import {useTranslation} from "react-i18next";

interface BreadcrumbsInlabProps {
    links: BreadcrumbLink[],
    showBackBtn?: boolean
}

const BreadcrumbsInlab = ({links, showBackBtn = false}: BreadcrumbsInlabProps) => {
    const {t} = useTranslation();

    const navigate = useNavigate()

    function handleBack() {
        if (links.length > 1) {
            navigate(links[links.length - 2].to);
        } else {
            navigate(-1);
        }
    }

    const lastIndex = links.length - 1;

    const crumbsTsx = links.map((link, index) => {
        if (index === lastIndex) {
            return <Typography key={link.to} color="text.primary">{link.title}</Typography>
        }
        return <Link key={link.to} underline="hover" color="inherit" to={link.to} component={RouterLink}>
            {link.title}
        </Link>
    });

    return (
      <Box sx={{p: 3}}>
          <ErrorsCatcher errorId="eb859f89-60e3-4921-b248-db09c30f20ce">
              <Breadcrumbs aria-label="breadcrumb">
                  {crumbsTsx}
              </Breadcrumbs>

              {showBackBtn && (
                <Button
                  variant="outlined"
                  onClick={handleBack}
                  sx={{mt: 2}}
                >
                    {t("Back")}
                </Button>
              )}
          </ErrorsCatcher>
      </Box>
    )
};

export default BreadcrumbsInlab;

export interface BreadcrumbLink {
    title: string,
    to: string,
}
